<template>
  <div class="wrap" :class="{'wrap-androidPC':currentType == enums.ANDROIDPC}">
    <keep-alive>
      <androidpc-search v-if="currentType == enums.ANDROIDPC"></androidpc-search>
      <input-search @query="queryByCode" @queryInput="handleInput" :value="currentInput" v-else></input-search>
    </keep-alive>
    <span class="viewChangeBtn iconfont" :class="classOfViewBtn" v-if="enableChange" v-tap.prevent="{ methods : changeViewType }"></span>
  </div>
</template>

<script>
  import androidpcSearch from './androidpc-search.vue'
  import inputSearch from './input-search.vue'
  import enums from '@/enums'

  export default {
    data(){
      return {
        currentType: this.viewType,
        currentInput: this.queryCode,
        enableChange: false, // 临时方案，因为一体机暂时只支持扫码，所以暂时写死，可同时支持扫码与输入后再开放props中对应属性
        enums
      }
    },
    props: {
      viewType: {
        type: Number,
        default: enums.ANDROIDPC
      },
      // enableChange: {
      //   type: Boolean,
      //   default: true
      // },
      queryCode: [Number, String]
    },
    watch: {
      queryCode(val){
        this.currentInput = val;
      }
    },
    computed: {
      classOfViewBtn: function () {
        return {
          'icon-qrcode': this.currentType == enums.PC,
          'icon-keyboard': this.currentType == enums.ANDROIDPC
        }
      }
    },
    methods: {
      changeViewType(){
        if (!this.enableChange) {
          return;
        }
        const currentType = this.currentType;
        if (currentType == enums.ANDROIDPC) {
          this.currentType = enums.PC
          this.$changeScanState(false);
        } else {
          this.currentType = enums.ANDROIDPC
          this.$changeScanState(true);
        }
      },
      queryByCode(code){
        this.$emit('query', code)
      },
      handleInput(code) {
        this.currentInput = code;
        this.$emit('queryInput', code);
      }
    },
    components: {
      androidpcSearch,
      inputSearch
    }
  }
</script>

<style lang='less' scoped>
  @import '../../assets/less/base.less';

  .wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    margin: auto;
    font-size: @font-size-larger;
    width: 620px;
    height: 380px;
    padding: 106px 55px 70px;
    background: #fff;
    .card-shadow;
  }

  .wrap-androidPC {
    background: #fff url('../../../static/androidPC.jpg') 50px top no-repeat;
    background-size: contain;
  }

  .viewChangeBtn {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 82px;
    height: 82px;
    font-size: 80px;
    color: @color-orange;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// searchWrap.vue?51710914